<template>
  <div class="w-100 p-y-2 m-b-6">
    <div class="container d-flex flex-center text-center fd-column">
      <img :src="image" class="IMAGE" alt="Looking for Something?">
      <div class="text-center">
        <h3 class="h3 m-b-0">{{content.title}}</h3>
        <p class="m-b-5">
          {{content.description}}
        </p>
        <div>
          <button
              class="btn-lg btn-secondary BUTTON"
              @click="goToHelpCenter()">
            {{content.cta}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'looking-for-something',
  components: {
  },
  computed: {
    ...mapGetters('homepage/contentful', [
      'proHomePage',
    ]),
    content () {
      return this.proHomePage.closingSection;
    },
    image () {
      return this.proHomePage.closingSection.image.fields.file.url;
    },
  },

  methods: {
    goToHelpCenter () {
      window.location.href = `${this.content.ctaUrl}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";
.BUTTON{
  width: $unit * 27.5;
}
.IMAGE{
  max-width: 96px;
}
</style>
